import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addUser } from "../features/users/userSlice";
import { toast } from "react-toastify";

function UserForm() {

    const dispatch = useDispatch();

    // =========================================================
    // USER FIELDS
    // =========================================================

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [role, setRole] = useState("user");

    const [isActive, setIsActive] = useState(true);


    // =========================================================
    // PERMISSIONS
    // =========================================================

    const defaultPermissions = {

        ledgers: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        suppliers: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        buyers: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        banks: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        transporters: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        despatchos: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        ports: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        shipping_lines: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        redex_companies: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        materials: {
            view: false,
            create: false,
            edit: false,
            delete: false
        },

        other_parties: {
            view: false,
            create: false,
            edit: false,
            delete: false
        }

    };


    const [permissions, setPermissions] =
        useState(defaultPermissions);


    // =========================================================
    // MODULE LABELS
    // =========================================================

    const permissionModules = [

        {
            key: "ledgers",
            label: "Ledgers",
            icon: "bi-journal-text"
        },

        {
            key: "suppliers",
            label: "Suppliers",
            icon: "bi-box-seam"
        },

        {
            key: "buyers",
            label: "Buyers",
            icon: "bi-person-check"
        },

        {
            key: "banks",
            label: "Banks",
            icon: "bi-bank"
        },

        {
            key: "transporters",
            label: "Transporters",
            icon: "bi-truck"
        },

        {
            key: "despatchos",
            label: "Despatchos",
            icon: "bi-send"
        },

        {
            key: "ports",
            label: "Ports",
            icon: "bi-geo-alt"
        },

        {
            key: "shipping_lines",
            label: "Shipping Lines",
            icon: "bi-water"
        },

        {
            key: "redex_companies",
            label: "Redex Companies",
            icon: "bi-building"
        },

        {
            key: "materials",
            label: "Materials",
            icon: "bi-box"
        },

        {
            key: "other_parties",
            label: "Other Parties",
            icon: "bi-three-dots"
        }

    ];


    // =========================================================
    // CLEAR FORM
    // =========================================================

    const clearForm = () => {

        setName("");
        setEmail("");
        setPassword("");

        setRole("user");

        setIsActive(true);

        setPermissions(defaultPermissions);

    };


    // =========================================================
    // CHANGE PERMISSION
    // =========================================================

    const handlePermissionChange = (
        module,
        permission,
        value
    ) => {

        setPermissions(prev => ({

            ...prev,

            [module]: {

                ...prev[module],

                [permission]: value

            }

        }));

    };


    // =========================================================
    // SELECT ALL MODULE PERMISSIONS
    // =========================================================

    const selectAllModule = (module) => {

        const allSelected =
            Object.values(
                permissions[module]
            ).every(Boolean);


        setPermissions(prev => ({

            ...prev,

            [module]: {

                view: !allSelected,
                create: !allSelected,
                edit: !allSelected,
                delete: !allSelected

            }

        }));

    };


    // =========================================================
    // ADMIN ROLE
    // =========================================================

    const handleRoleChange = (value) => {

        setRole(value);

        // Admin automatically gets full access

        if (value === "admin") {

            const adminPermissions = {};

            Object.keys(defaultPermissions)
                .forEach(module => {

                    adminPermissions[module] = {

                        view: true,
                        create: true,
                        edit: true,
                        delete: true

                    };

                });

            setPermissions(adminPermissions);

        } else {

            // Reset permissions when changing
            // Admin -> User

            setPermissions(defaultPermissions);

        }

    };


    // =========================================================
    // SUBMIT
    // =========================================================
	
	const handleSubmit = async (e) => {

    e.preventDefault();

    if (!name.trim()) {
        toast.error("Please enter user name.");
        return;
    }

    if (!email.trim()) {
        toast.error("Please enter email.");
        return;
    }

    if (!password.trim()) {
        toast.error("Please enter password.");
        return;
    }

    if (password.length < 6) {
        toast.error(
            "Password must contain at least 6 characters."
        );
        return;
    }

    const userData = {

        name: name.trim(),

        email: email.trim(),

        password: password,

        role: role,

        isActive: isActive,

        permissions:
            role === "admin"
                ? Object.keys(defaultPermissions).reduce(
                    (result, module) => {

                        result[module] = {
                            view: true,
                            create: true,
                            edit: true,
                            delete: true
                        };

                        return result;

                    },
                    {}
                )
                : permissions
    };

    console.log("Submitting User:", userData);

    try {

        await dispatch(
            addUser(userData)
        ).unwrap();

        toast.success(
            "User added successfully."
        );

        clearForm();

    } catch (error) {

        toast.error(
            error ||
            "Unable to add user."
        );
    }
};

    const handleSubmitxxx = async (e) => {

        e.preventDefault();


        if (!name.trim()) {

            toast.error(
                "Please enter user name."
            );

            return;

        }


        if (!email.trim()) {

            toast.error(
                "Please enter email."
            );

            return;

        }


        if (!password.trim()) {

            toast.error(
                "Please enter password."
            );

            return;

        }


        if (password.length < 6) {

            toast.error(
                "Password must contain at least 6 characters."
            );

            return;

        }


        const userData = {

            name: name.trim(),

            email: email.trim(),

            password: password,

            role: role,

            isActive: isActive,

            permissions:
                role === "admin"
                    ? Object.keys(
                        defaultPermissions
                    ).reduce(
                        (result, module) => {

                            result[module] = {

                                view: true,
                                create: true,
                                edit: true,
                                delete: true

                            };

                            return result;

                        },
                        {}
                    )
                    : permissions

        };

	//console.log(userData);
	console.log("Submitting User:", userData);
        try {

            await dispatch(
                addUser(userData)
            ).unwrap();


            toast.success(
                "User added successfully."
            );


            clearForm();


        } catch (error) {

            toast.error(
                error ||
                "Unable to add user."
            );

        }

    };


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <div className="card shadow border-0">

            {/* =================================================
                HEADER
            ================================================== */}

            <div className="card-header bg-primary text-white">

                <h5 className="mb-0">

                    <i className="bi bi-person-plus-fill me-2"></i>

                    Add User

                </h5>

            </div>


            <div className="card-body">

                <form onSubmit={handleSubmit}>


                    {/* =================================================
                        NAME
                    ================================================== */}

                    <div className="mb-3">

                        <label className="form-label fw-semibold">

                            Name

                        </label>

                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter user name"
                            value={name}
                            onChange={(e) =>
                                setName(e.target.value)
                            }
                            required
                        />

                    </div>


                    {/* =================================================
                        EMAIL
                    ================================================== */}

                    <div className="mb-3">

                        <label className="form-label fw-semibold">

                            Email

                        </label>

                        <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email address"
                            value={email}
                            onChange={(e) =>
                                setEmail(e.target.value)
                            }
                            required
                        />

                    </div>


                    {/* =================================================
                        PASSWORD
                    ================================================== */}

                    <div className="mb-3">

                        <label className="form-label fw-semibold">

                            Password

                        </label>

                        <input
                            type="password"
                            className="form-control"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) =>
                                setPassword(e.target.value)
                            }
                            minLength={6}
                            required
                        />

                        <small className="text-muted">

                            Minimum 6 characters.

                        </small>

                    </div>


                    {/* =================================================
                        ROLE
                    ================================================== */}

                    <div className="mb-3">

                        <label className="form-label fw-semibold">

                            Role

                        </label>

                        <select
                            className="form-select"
                            value={role}
                            onChange={(e) =>
                                handleRoleChange(
                                    e.target.value
                                )
                            }
                        >

                            <option value="user">
                                User
                            </option>

                            <option value="admin">
                                Admin
                            </option>

                        </select>

                    </div>


                    {/* =================================================
                        STATUS
                    ================================================== */}

                    <div className="mb-3">

                        <div className="form-check form-switch">

                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isActive}
                                onChange={(e) =>
                                    setIsActive(
                                        e.target.checked
                                    )
                                }
                            />

                            <label className="form-check-label">

                                Active User

                            </label>

                        </div>

                    </div>


                    {/* =================================================
                        PERMISSIONS
                    ================================================== */}

                    <div className="card border mb-3">

                        <div className="card-header bg-light">

                            <div className="d-flex justify-content-between align-items-center">

                                <strong>

                                    <i className="bi bi-shield-lock me-2"></i>

                                    Permissions

                                </strong>


                                {role === "admin" && (

                                    <span className="badge bg-danger">

                                        Full Access

                                    </span>

                                )}

                            </div>

                        </div>


                        <div className="card-body p-2">

                            {role === "admin" ? (

                                <div className="alert alert-danger mb-0">

                                    <i className="bi bi-shield-check me-2"></i>

                                    Admin users automatically have
                                    full access to all modules.

                                </div>

                            ) : (

                                <div className="table-responsive">

                                    <table className="table table-sm align-middle mb-0">

                                        <thead className="table-light">

                                            <tr>

                                                <th>
                                                    Module
                                                </th>

                                                <th className="text-center">
                                                    View
                                                </th>

                                                <th className="text-center">
                                                    Create
                                                </th>

                                                <th className="text-center">
                                                    Edit
                                                </th>

                                                <th className="text-center">
                                                    Delete
                                                </th>

                                                <th className="text-center">
                                                    All
                                                </th>

                                            </tr>

                                        </thead>


                                        <tbody>

                                            {permissionModules.map(
                                                (module) => {

                                                    const modulePermissions =
                                                        permissions[
                                                            module.key
                                                        ];

                                                    const allSelected =
                                                        Object.values(
                                                            modulePermissions
                                                        ).every(
                                                            Boolean
                                                        );


                                                    return (

                                                        <tr
                                                            key={
                                                                module.key
                                                            }
                                                        >

                                                            {/* MODULE */}

                                                            <td>

                                                                <i
                                                                    className={`bi ${module.icon} me-2`}
                                                                ></i>

                                                                <span className="fw-semibold">

                                                                    {
                                                                        module.label
                                                                    }

                                                                </span>

                                                            </td>


                                                            {/* VIEW */}

                                                            <td className="text-center">

                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={
                                                                        modulePermissions.view
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handlePermissionChange(
                                                                            module.key,
                                                                            "view",
                                                                            e.target.checked
                                                                        )
                                                                    }
                                                                />

                                                            </td>


                                                            {/* CREATE */}

                                                            <td className="text-center">

                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={
                                                                        modulePermissions.create
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handlePermissionChange(
                                                                            module.key,
                                                                            "create",
                                                                            e.target.checked
                                                                        )
                                                                    }
                                                                />

                                                            </td>


                                                            {/* EDIT */}

                                                            <td className="text-center">

                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={
                                                                        modulePermissions.edit
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handlePermissionChange(
                                                                            module.key,
                                                                            "edit",
                                                                            e.target.checked
                                                                        )
                                                                    }
                                                                />

                                                            </td>


                                                            {/* DELETE */}

                                                            <td className="text-center">

                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={
                                                                        modulePermissions.delete
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handlePermissionChange(
                                                                            module.key,
                                                                            "delete",
                                                                            e.target.checked
                                                                        )
                                                                    }
                                                                />

                                                            </td>


                                                            {/* ALL */}

                                                            <td className="text-center">

                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={
                                                                        allSelected
                                                                    }
                                                                    onChange={() =>
                                                                        selectAllModule(
                                                                            module.key
                                                                        )
                                                                    }
                                                                />

                                                            </td>

                                                        </tr>

                                                    );

                                                }
                                            )}

                                        </tbody>

                                    </table>

                                </div>

                            )}

                        </div>

                    </div>


                    {/* =================================================
                        SAVE BUTTON
                    ================================================== */}

                    <button
                        type="submit"
                        className="btn btn-primary w-100"
                    >

                        <i className="bi bi-save me-2"></i>

                        Save User

                    </button>


                </form>

            </div>

        </div>

    );

}

export default UserForm;
